export const defaultPension = {
  status: 'STARTED',
  fixedAmount: 0,
  amount: 0,
  reversionaryBeneficiary: {},
  segregation: {},
  finalChecks: {},
};

export const defaultPensionKitEstablishment = {
  name: '',
  requirements: {
    startDate: '',
    member: {
      name: '',
      age: 0,
      dateOfBirth: '',
      preservationAge: 0,
    },
    eligibility: {
      reasons: '',
      otherReason: 'I have sufficient unrestricted non-preserved superannuation to do so, having met a condition of release in the past.',
      acknowledge: null,
    },
    ratify: null,
  },
  setup: {
    howMuch: '',
    accumulationKnown: '',
    taxComponentKnown: '',
    transferBalanceCapKnown: '',
    part: 'PART_1',
  },
  accumulation: {
    amount: 0,
    unrestrictedNonPreserve: 0,
    components: {
      taxable: {
        value: 0,
        percent: 0,
      },
      nonTaxable: {
        value: 0,
        percent: 1,
      },
    },
    status: 'STARTED',
  },
  pensions: [],
  activePension: null,
};

export default defaultPensionKitEstablishment;
